<div class="message-card blue-fill mb-3">
  <div class="mb-3">
    <mwp-text-translate text="Below is a summary of your benefit elections. Please review these carefully before clicking" jsonKey="summaryNote" />
    <strong class="secondary-font-color">
      <mwp-text-translate text="CONFIRM" jsonKey="confirm" />
    </strong>
  </div>
  <div>
    <mwp-text-translate text="Once you confirm, you will be prompted to authorize and sign for your elections. If you wish to modify any of your elections, click the corresponding benefits category from the timeline at the top. Once you are done, return to the Checkout section to finalize your elections" jsonKey="summaryOnceYouConfirm" />
  </div>
</div>
<div class="content-container table-comp mb-3">
  <div class="title">
    <mwp-text-translate text="Summary" jsonKey="summary" />
  </div>
  <div class="content p-0">
    <mwp-card-benefit-summary [benefitSummaryList]="benefitSummaryList" [isNoBorder]="true" [isEnrollmentCheckout]="true" [displayBenefitColumn]="true" [showSummary]="false" [enableToggle]="true" />
  </div>
</div>
@for (summaryTotalCard of benefitSummaryList.summaryTotalCards; track summaryTotalCard) {
  <div class="mb-3">
    <mwp-deduction-summary [displayTotalCard]="true" [isNoBorder]="false" [benefitTotal]="summaryTotalCard" />
  </div>
}
@if (benefitSummaryList.summaryTotalCards.length > 1) {
  <div class="mb-3 message-card d-inline-flex justify-content-between w-100">
    <div>
      <mwp-text-translate text="Deductions Total" jsonKey="summaryDeductionsTotal" />
    </div>
    <div>
      <span>{{ totalAmount | currency }}</span>
    </div>
  </div>
}
<div class="content-container mb-3">
  <div class="title">
    <mwp-text-translate text="Notice" jsonKey="notice" />
  </div>
  <div class="content font-sm">
    <div [innerHTML]="benefitSummaryList.messageHTML | pipeSafeHTML">
    </div>
  </div>
</div>
<div>
  <mwp-benefit-enrollment-wizard-control [isCheckout]="true" (emitComplete)="complete()" />
</div>